<template>
    <ListeTypeDocument />
  </template>
  
  <script lang="ts">
import ListeTypeDocument from "@/components/GesCom/Document/ListeTypeDocument.vue";
import { defineComponent } from "vue";
  
      
    export default defineComponent({
      name: "ListeTypeDocumentPage",
      components: {
        
        ListeTypeDocument
      },
    });
  </script>